import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

const PopupCards = ({
    lang,
    pageClass,
    dataCard1,
    dataCard2,
    switcher_1,
    switcher_2,
    activeCard,
    setActiveCard,
    fetchTableData,
}) => {
    const dataTranslate = require(`../../translate/${lang === "AR" ? "arabic" : "english"
        }/data.json`);

    const [singleSection, setSingleSection] = useState(false);

    useEffect(() => {
        if (!dataCard1 || !dataCard2) {
            setSingleSection(() => true);
        } else {
            setSingleSection(() => false);
        }
    }, []);
    return (
        <div
            className={`${pageClass}-cards w-100 d-flex flex-row ${singleSection
                ? "align-items-center justify-content-center"
                : "align-items-start justify-content-between"
                }`}
        >
            {dataCard1 ? (
                <div className={`${pageClass}-cards-section1`}>
                    <Container
                        className={`d-flex align-items-center justify-content-${singleSection ? "center" : "start"
                            }`}
                    >
                        <Row className="gap-3">
                            {dataCard1.map((item, index) => {
                                let { key, title } = switcher_1(item, dataTranslate);
                                return (
                                    <Col
                                        key={index}
                                        onClick={() => {
                                            setActiveCard(key);
                                            fetchTableData(key);
                                        }}
                                    >
                                        <Card className={`${pageClass}-cards-section1-card`}>
                                            <Card.Body
                                                className={
                                                    activeCard === key
                                                        ? "active-card d-flex flex-column align-items-center text-center"
                                                        : "d-flex flex-column align-items-center text-center"
                                                }
                                            >
                                                <Card.Title>{title}</Card.Title>
                                                <h1 dir="ltr"> {item[key]}</h1>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Container>
                </div>
            ) : (
                ""
            )}
            {dataCard2 ? (
                <div className={`${pageClass}-cards-section2`}>
                    <Container className="d-flex align-items-center justify-content-end">
                        <Row className="gap-3">
                            {dataCard2.map((item, index) => {
                                let { key, title } = switcher_2(item, dataTranslate);
                                return (
                                    <Col key={index}>
                                        <Card className={`${pageClass}-cards-section2-card`}>
                                            <Card.Body className="d-flex flex-column align-items-center text-center">
                                                <Card.Title className="h2 mb-5">{title}</Card.Title>

                                                {item[key].dollar ? <>
                                                    <div className="w-100 d-flex flex-row align-items-center justify-content-between">
                                                        <span className="h5">
                                                            {dataTranslate.pages.home_p.cards.dollar}
                                                        </span>
                                                        <span dir="ltr" className="h5">
                                                            {item[key].dollar}
                                                        </span>
                                                    </div></> : ""}

                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Container>
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default PopupCards;
